// extracted by mini-css-extract-plugin
export default {"App":"App_App__zFxWE","App__arrow":"App_App__arrow__qyTZf"};